import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import WeekDaySelector from 'src/Elements/Selectors/WeekDaySelector'
import { Days } from '@e3dc-react/shell/Libs/date/types'
import { makeStyles } from 'tss-react/mui'
import { useFormContext, useWatch } from 'react-hook-form'
import { ChargingScheduleFormFieldNames, ChargingScheduleFormType, RepeatOptions } from 'src/Libs/e-mobility/vehicle-integration'

const useStyles = makeStyles()(theme => ({
  weekDays: {
    flexWrap: 'wrap',
  },
}))

/* Schedule repeat label and select form part */
const ScheduleRepeatLabel: React.FC = () => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const {
    control,
    setValue,
    formState: { errors },
  } = useFormContext<ChargingScheduleFormType>()
  const selectedWeekDays = useWatch({ control, name: ChargingScheduleFormFieldNames.SelectedWeekDays })

  const handleSelectedWeekDayChange = (day: keyof Days, selected: boolean): void => {
    const updatedWeekDays = { ...selectedWeekDays, [day]: selected } as Days
    setValue(ChargingScheduleFormFieldNames.SelectedWeekDays, updatedWeekDays, { shouldDirty: true, shouldValidate: true })
    // if all weekdays are selected, set "repeat" to daily and vice versa
    const allSelected = Object.values(updatedWeekDays).every(Boolean)
    setValue(ChargingScheduleFormFieldNames.Repeat, allSelected ? RepeatOptions.daily : RepeatOptions.weekly, {
      shouldDirty: true,
      shouldValidate: true,
    })
  }

  return (
    <Stack gap={2} direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h3" sx={{ flex: 1 }}>
        {t('emobility.vehicle-integration.charging-schedule.repeat-label')}
      </Typography>
      <Box sx={{ flex: 1 }}>
        <WeekDaySelector disabledDays={[]} onSelectDay={handleSelectedWeekDayChange} days={selectedWeekDays} className={classes.weekDays} />
        {errors[ChargingScheduleFormFieldNames.SelectedWeekDays]?.message && (
          <Typography color="error" variant="caption" sx={{ marginLeft: '14px' }}>
            {errors[ChargingScheduleFormFieldNames.SelectedWeekDays].message}
          </Typography>
        )}
      </Box>
    </Stack>
  )
}

export default ScheduleRepeatLabel
